import dayjs from 'dayjs'
import { DATE_FORMAT } from '../../consts'

export const dateToString = (inputDate: Date | null): string | null =>
  inputDate ? dayjs(inputDate).format('YYYY-MM-DD') : null

export const parseDateTime = (dateTime: string | Date): string => {
  return dayjs(dateTime).format(DATE_FORMAT + ' hh:mmA')
}
